// Action Types
export const GLOBAL_MEM_REQUEST = "GLOBAL_MEM_REQUEST";
export const GLOBAL_MEM_SUCCESS = "GLOBAL_MEM_SUCCESS";
export const GLOBAL_MEM_FAILURE = "GLOBAL_MEM_FAILURE";
export const LIST_GLOBAL_MEM_REQUEST = "LIST_GLOBAL_MEM_REQUEST";
export const LIST_GLOBAL_MEM_SUCCESS = "LIST_GLOBAL_MEM_SUCCESS";
export const LIST_GLOBAL_MEM_FAILURE = "LIST_GLOBAL_MEM_FAILURE";
export const LIST_GLOBAL_MEM_DOCS_REQUEST = "LIST_GLOBAL_MEM_DOCS_REQUEST";
export const LIST_GLOBAL_MEM_DOCS_SUCCESS = "LIST_GLOBAL_MEM_DOCS_SUCCESS";
export const LIST_GLOBAL_MEM_DOCS_FAILURE = "LIST_GLOBAL_MEM_DOCS_FAILURE";

// Action Creators
export const globalMemRequest = ({ files, userId, promptData, webUrl,fileIds,clientName,accountName,memoryType,opportunityId,tabs=[],isAdmin}) => {
  return (dispatch) => {
    dispatch({
      type: GLOBAL_MEM_REQUEST,
      payload: { files, userId, promptData, webUrl,fileIds,clientName,accountName,memoryType,opportunityId,tabs,isAdmin},
    });
  };
};

export const globalMemSuccess = (data) => ({
  type: GLOBAL_MEM_SUCCESS,
  payload: data,
});

export const globalMemFailure = (error) => ({
  type: GLOBAL_MEM_FAILURE,
  payload: error,
});

export const listGlobalMemRequestPlainLoad = ({userId,memoryType}) => {

return{
      type: LIST_GLOBAL_MEM_REQUEST,
      payload: { userId,memoryType},
    };

};


export const listGlobalMemRequest = ({userId,memoryType,opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: LIST_GLOBAL_MEM_REQUEST,
      payload: { userId,memoryType,opportunityId},
      
    });
  };
};

export const listGlobalMemSuccess = (data) => ({
  type: LIST_GLOBAL_MEM_SUCCESS,
  payload: data,
});

export const listGlobalMemFailure = (error) => ({
  type: LIST_GLOBAL_MEM_FAILURE,
  payload: error,
});



export const listGlobalMemDocsRequest = ({userId}) => {
  return (dispatch) => {
    dispatch({
      type: LIST_GLOBAL_MEM_DOCS_REQUEST,
      payload: { userId},
    });
  };
};

export const listGlobalMemDocsSuccess = (data) => ({
  type: LIST_GLOBAL_MEM_DOCS_SUCCESS,
  payload: data,
});

export const listGlobalMemDocsFailure = (error) => ({
  type: LIST_GLOBAL_MEM_DOCS_FAILURE,
  payload: error,
});